export interface IResponse {
    success?: boolean;
    message?: string;
}